import { useEffect, useState, useMemo } from "react";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";
import MDButton from "components/MDButton";
import MDInput from "components/MDInput";
import Icon from "@mui/material/Icon";
import { Grid, InputAdornment, Box, Typography, Avatar } from "@mui/material";
import { CloudUpload } from "@mui/icons-material";
import { useMaterialUIController } from "context";
import axios from "axios";
import BASE_URL from "config/Base_URL";
import MyModal from "components/Modal";
import Swal from "sweetalert2";
import imageCompression from "browser-image-compression";

const DataTableProduk = (searchText = "") => {
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;
  const [listProduk, setListProduk] = useState([]);
  const token = sessionStorage.getItem("token");

  const [idProduk, setIdProduk] = useState("");
  const [namaProduk, setNamaProduk] = useState("");
  const [unit, setUnit] = useState("");
  const [harga, setHarga] = useState("");
  const [gambar, setGambar] = useState(null);
  const [deskripsi, setDeskripsi] = useState("");

  const [modalEditShow, setModalEditShow] = useState(false);
  const [modalDetailShow, setModalDetailShow] = useState(false);
  const [modalDeleteShow, setModalDeleteShow] = useState(false);

  const formatRupiah = (number) => {
    if (!number) return "";
    return new Intl.NumberFormat("id-ID", {
      style: "currency",
      currency: "IDR",
      minimumFractionDigits: 0,
    }).format(number);
  };

  // ================================================================
  //                                 DELETE
  // ================================================================

  const handleDelete = async () => {
    try {
      const response = await axios.delete(`${BASE_URL}/product/delete/${idProduk}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setModalDeleteShow(false);
      Swal.fire("Berhasil", "Produk berhasil dihapus", "success");
      fetchProducts();
    } catch (error) {
      console.log(error);
      setModalDeleteShow(false);
      Swal.fire("Gagal", "Produk gagal dihapus", "error");
    }
  };

  // ================================================================
  //                                 EDIT
  // ================================================================

  const handleEdit = (produk) => {
    setIdProduk(produk.id);
    setNamaProduk(produk.name);
    setUnit(produk.unit);
    setHarga(produk.price);
    setGambar(produk.picture);
    setDeskripsi(produk.description);
    setModalEditShow(true);
  };

  const allowedTypes = ["image/jpeg", "image/png", "image/jpg"];

  const handleImageUpload = async (e) => {
    const file = e.target.files[0];
    if (!file) return;

    // Ekstensi validasi manual dari nama file (ekstensi lowercase)
    const ext = file.name.split(".").pop().toLowerCase();
    const validExt = ["jpg", "jpeg", "png"];
    if (!validExt.includes(ext)) {
      Swal.fire("Gagal", "Format file harus JPG atau PNG", "error");
      return;
    }

    // Validasi type MIME
    if (!allowedTypes.includes(file.type)) {
      Swal.fire("Gagal", "Tipe file tidak didukung. Hanya JPG dan PNG!", "error");
      return;
    }

    const originalSizeMB = parseFloat((file.size / 1024 / 1024).toFixed(1));
    let finalFile = file;

    if (file.size >= 2 * 1024 * 1024) {
      try {
        const options = {
          maxSizeMB: 2,
          maxWidthOrHeight: 1080,
          useWebWorker: true,
        };

        const compressedBlob = await imageCompression(file, options);

        const newFileName = `${file.name.split(".")[0]}.${ext}`;
        const compressedFile = new File([compressedBlob], newFileName, {
          type: compressedBlob.type,
          lastModified: Date.now(),
        });

        const compressedSizeMB = parseFloat((compressedFile.size / 1024 / 1024).toFixed(1));

        if (compressedFile.size >= 2 * 1024 * 1024) {
          Swal.fire("Gagal", "Ukuran gambar setelah dikompres masih di atas 2MB", "error");
          return;
        }

        finalFile = compressedFile;

        console.log("Sebelum:", originalSizeMB, "MB");
        console.log("Sesudah:", compressedSizeMB, "MB");
        console.log("Nama file hasil kompresi:", compressedFile.name);
      } catch (error) {
        console.error("Gagal mengompres gambar:", error);
        Swal.fire("Gagal", "Terjadi kesalahan saat kompresi gambar", "error");
        return;
      }
    } else {
      console.log("Ukuran gambar:", originalSizeMB, "MB (tidak dikompres)");
    }

    setGambar(finalFile); // digunakan di edit
  };

  function base64ToFile(base64String, fileName = "image.jpg") {
    const arr = base64String.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);
    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }
    return new File([u8arr], fileName, { type: mime });
  }

  const handleSubmitEdit = async () => {
    try {
      const formDataEdit = new FormData();

      formDataEdit.append("id", idProduk);
      formDataEdit.append("nameProduct", namaProduk);
      formDataEdit.append("unit", unit);
      formDataEdit.append("price", harga);
      formDataEdit.append("description", deskripsi);

      if (gambar) {
        if (typeof gambar === "string" && gambar.length > 100) {
          let base64 = gambar;
          if (!gambar.startsWith("data:image")) {
            base64 = "data:image/jpeg;base64," + gambar;
          }

          const file = base64ToFile(base64, "image.jpg");
          formDataEdit.append("picture", file);
        } else if (gambar instanceof File || gambar instanceof Blob) {
          // Validasi ulang type
          const ext = gambar.name.split(".").pop().toLowerCase();
          if (!["jpg", "jpeg", "png"].includes(ext)) {
            Swal.fire("Gagal", "Ekstensi file gambar harus JPG atau PNG", "error");
            return;
          }

          formDataEdit.append("picture", gambar);
        }
      }

      for (let [key, value] of formDataEdit.entries()) {
        console.log(`${key}:`, value);
      }

      // console.log(gambar);
      const response = await axios.put(`${BASE_URL}/update/product`, formDataEdit, {
        headers: {
          Authorization: `Bearer ${token}`,
          // "Content-Type": "multipart/form-data",
        },
      });

      setModalEditShow(false);
      fetchProducts();
      Swal.fire("Berhasil", "Produk berhasil diperbarui!", "success");
    } catch (error) {
      setModalEditShow(false);
      console.error("Error saat update produk:", error);
      Swal.fire("Gagal", "Gagal memperbarui produk!", "error");
    }
  };

  const renderForm = (
    <Grid container spacing={2} maxWidth="lg">
      {/* Gambar Produk (opsional) */}
      <Grid item xs={12}>
        <MDBox mb={2}>
          <Typography variant="body2" gutterBottom>
            Gambar Produk (opsional)
          </Typography>

          {gambar ? (
            <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
              <Avatar
                src={(() => {
                  if (!gambar) return `${process.env.REACT_APP_API_URL}/api/images/placeholder.png`;

                  if (typeof gambar === "string") {
                    if (gambar.startsWith("data:image")) {
                      return gambar;
                    } else {
                      return `${BASE_URL}/images/${gambar}`;
                    }
                  }

                  if (gambar instanceof File || gambar instanceof Blob) {
                    return URL.createObjectURL(gambar); // File atau Blob valid
                  }

                  return `${process.env.REACT_APP_API_URL}/api/images/placeholder.png`; // Fallback terakhir
                })()}
                variant="rounded"
                sx={{ width: 250, height: 250 }}
              />
              <MDButton variant="outlined" color="error" onClick={() => setGambar(null)}>
                Hapus Gambar
              </MDButton>
            </Box>
          ) : (
            <MDButton
              component="label"
              variant="outlined"
              color="secondary"
              fullWidth
              startIcon={<CloudUpload />}
            >
              Pilih Gambar
              <input type="file" accept=".jpg,.jpeg,.png" hidden onChange={handleImageUpload} />
            </MDButton>
          )}
          <Typography variant="caption" display="block" mt={1}>
            Format: JPG, PNG (Maks. 2MB)
          </Typography>
        </MDBox>
      </Grid>

      {/* Nama Produk */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            size="xxl"
            label="Nama Produk"
            variant="outlined"
            value={namaProduk}
            onChange={(e) => setNamaProduk(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            required
          />
        </MDBox>
      </Grid>

      {/* Unit */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="Unit (contoh: pcs, kg, liter)"
            variant="outlined"
            value={unit}
            onChange={(e) => setUnit(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            required
          />
        </MDBox>
      </Grid>

      {/* Harga */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="Harga"
            variant="outlined"
            type="text"
            value={formatRupiah(harga)}
            onChange={(e) => {
              const onlyNums = e.target.value.replace(/[^0-9]/g, "");
              setHarga(onlyNums);
            }}
            required
          />
        </MDBox>
      </Grid>

      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            label="Deskripsi Produk"
            variant="outlined"
            value={deskripsi}
            onChange={(e) => setDeskripsi(e.target.value.toUpperCase())}
            InputLabelProps={{ shrink: true }}
            multiline
            required
            rows={3}
            sx={{
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
              },
              "& textarea": {
                resize: "vertical",
                minHeight: "80px",
              },
            }}
          />
          <Typography variant="caption" color="textSecondary">
            Maksimal 500 karakter • {deskripsi.length}/500
          </Typography>
        </MDBox>
      </Grid>
    </Grid>
  );

  // ==================================================================
  //                               GET PRODUK
  // ==================================================================

  useEffect(() => {
    fetchProducts();
  }, []);

  const fetchProducts = async () => {
    try {
      const response = await axios.get(`${BASE_URL}/products`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setListProduk(response.data.data);
      console.log(response.data.data);
    } catch (error) {
      console.error("Gagal menampilkan produk:", error);
    }
  };

  // ===================================================================
  //                                DETAIL
  // ===================================================================

  const handleDetail = async (produk) => {
    try {
      const response = await axios.get(`${BASE_URL}/products/${produk.id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      const produkResponse = response.data.data;
      setIdProduk(produkResponse.id);
      setNamaProduk(produkResponse.name);
      setUnit(produkResponse.unit);
      setHarga(produkResponse.price);
      setGambar(produkResponse.picture);
      setDeskripsi(produkResponse.description);

      setModalDetailShow(true);
    } catch (error) {
      console.log(error);
      Swal.fire("Gagal", "Gagal mengambil data produk!", "error");
    }
  };

  const renderFormDetail = (
    <Grid container spacing={2} maxWidth="lg">
      {/* Gambar Produk (opsional) */}
      <Grid item xs={12}>
        <MDBox mb={2}>
          <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", gap: 2 }}>
            <Avatar
              src={(() => {
                if (!gambar) return `${process.env.REACT_APP_API_URL}/api/images/placeholder.png`;

                if (typeof gambar === "string") {
                  if (gambar.startsWith("data:image")) {
                    return gambar;
                  } else {
                    return `${BASE_URL}/images/${gambar}`;
                  }
                }

                if (gambar instanceof File || gambar instanceof Blob) {
                  return URL.createObjectURL(gambar);
                }

                return `${process.env.REACT_APP_API_URL}/api/images/placeholder.png`;
              })()}
              variant="rounded"
              sx={{ width: 250, height: 250 }}
            />
          </Box>
        </MDBox>
      </Grid>

      {/* Nama Produk */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            size="xxl"
            label="Nama Produk"
            variant="outlined"
            value={namaProduk}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Unit */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="Unit (contoh: pcs, kg, liter)"
            variant="outlined"
            value={unit}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Harga */}
      <Grid item xs={12} md={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="Harga"
            variant="outlined"
            value={formatRupiah(harga)}
            InputLabelProps={{ shrink: true }}
          />
        </MDBox>
      </Grid>

      {/* Deskripsi */}
      <Grid item xs={12}>
        <MDBox mb={2}>
          <MDInput
            fullWidth
            disabled
            label="Deskripsi Produk"
            variant="outlined"
            value={deskripsi}
            InputLabelProps={{ shrink: true }}
            multiline
            rows={3}
            sx={{
              "& .MuiOutlinedInput-root": {
                alignItems: "flex-start",
              },
              "& textarea": {
                resize: "vertical",
                minHeight: "80px",
              },
            }}
          />
          <Typography variant="caption" color="textSecondary">
            Maksimal 500 karakter • {deskripsi.length}/500
          </Typography>
        </MDBox>
      </Grid>
    </Grid>
  );

  const columns = useMemo(
    () => [
      { Header: "No", accessor: "no", width: "5%", align: "left" },
      { Header: "Gambar", accessor: "gambar", align: "center" },
      { Header: "Nama Produk", accessor: "nama_produk", align: "center" },
      { Header: "Unit", accessor: "unit", align: "center" },
      { Header: "Harga", accessor: "harga", align: "center" },
      { Header: "Deskripsi", accessor: "deskripsi", align: "center" },
      { Header: "Action", accessor: "action", align: "center" },
    ],
    []
  );

  const filteredListProduk = useMemo(() => {
    if (!searchText) return listProduk;

    return listProduk.filter((item) =>
      (item.name || item.nama_produk || "").toLowerCase().includes(searchText.toLowerCase())
    );
  }, [listProduk, searchText]);

  // Baris
  const rows = useMemo(
    () =>
      filteredListProduk.map((item, index) => ({
        no: index + 1,
        gambar: (
          <MDAvatar
            src={`${BASE_URL}/images/${item.picture}`}
            name={item.name || item.nama_produk || "Product Image"}
            sx={{ width: "100px", height: "100px", backgroundSize: "cover" }}
            variant="rounded"
          />
        ),
        nama_produk: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.name || item.nama_produk}
          </MDTypography>
        ),
        unit: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.unit}
          </MDTypography>
        ),
        harga: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {formatRupiah(item.price || "0")}
          </MDTypography>
        ),
        deskripsi: (
          <MDTypography variant="caption" color={darkMode ? "white" : "dark"} fontWeight="medium">
            {item.description || item.deskripsi}
          </MDTypography>
        ),
        action: (
          <MDBox display="flex" alignItems="center" justifyContent="center">
            <MDBox mr={1}>
              <MDButton
                variant="text"
                color="error"
                onClick={() => {
                  setModalDeleteShow(true);
                  setIdProduk(item.id);
                }}
              >
                <Icon>delete</Icon>&nbsp;delete
              </MDButton>
            </MDBox>
            <MDBox mr={1}>
              <MDButton variant="text" color="success" onClick={() => handleEdit(item)}>
                <Icon>edit</Icon>&nbsp;edit
              </MDButton>
            </MDBox>
            <MDButton variant="text" color="info" onClick={() => handleDetail(item)}>
              <Icon>priority_high</Icon>&nbsp;detail
            </MDButton>
          </MDBox>
        ),
      })),
    [filteredListProduk, darkMode]
  );

  const modalEdit = (
    <MyModal
      show={modalEditShow}
      onHide={() => setModalEditShow(false)}
      title="Edit Produk"
      body={renderForm}
      onSubmit={handleSubmitEdit}
      submitText="Simpan"
      colorButtonSubmit="info"
    />
  );

  const modalDetail = (
    <MyModal
      show={modalDetailShow}
      onHide={() => setModalDetailShow(false)}
      title="Detail Produk"
      body={renderFormDetail}
    />
  );

  const modalDelete = (
    <MyModal
      show={modalDeleteShow}
      submitText="Hapus"
      variant="danger"
      onSubmit={handleDelete}
      onHide={() => setModalDeleteShow(false)}
      colorButtonSubmit="primary"
      body="Apakah anda yakin ingin menghapus data ini?"
    />
  );

  return { columns, rows, modalEdit, modalDetail, modalDelete, listProduk };
};

export default DataTableProduk;
